import img from './Mainimg';

const ContData = [
	{
		'id': 1,
		'tit':'idea!',
		'p': <div className="des-p">
			<b>firstly</b><br/>
                a client tell our call center about a problem that causees low performance in the business he has or a startup <br/>
			<b>some of these potential problems:</b><br />
			<ol>
				<li>deficiency the earn and the income of the business or a startup</li>
				<li>deficiency the client slices it will weak the income of the business</li>
				<li>general weakness in any part of the business or a startup</li>
				<li>low production size or quality of the production or weakness in any side at the production process</li>
			</ol>
		</div>,
		'img': img[0]
	},
	{
		'id': 2,
		'tit':'then -->',
		'p': <p className="des-p">
			<b>SASKE Company crew will take this task </b>
                we will do some research about your business <br />
                and all problems which you are facing and what is the best way
                to solve them.
			<br />
                through our researche, we will make a plan and strategy and then define our main and
                secondary targets to solve theses problems to work more
                efficiently in order to determine our idea of software that will be to solve all problems In a timely manner
                and be able to follow the solution and its effectiveness in
                solving the problem.
			<br />
                finally, we will do the previous steps to can measure the
                effectiveness of our software in solving your problems.
		</p>,
		'img': img[1]
	},
	{
		'id': 3,
		'tit':'step 2:',
		'p': <p className="des-p">
                in next step
			<br />
                a UX designer from our crew team will design a good wireframe
			<br />
                in this step, our target is to make a simple, easy design to
                make the user journey when using our software is so easy <br />
                and by this step, we will be sure our solution will be an
                entertainment experience <br />
                and your users will be happy when using it.
		</p>,
		'img': img[2]
	},
	{
		'id': 4,
		'tit':'step 3:',
		'p': <p className="des-p">
			<b>in third step</b>
			<br />
                    an ui designer from SASKE team will design a beauty and
                    attractive colorful design
			<br />
                    for our app which debend on final ux design which designed in the previous step . <br /> in
                    in this step our target is making attractive design and expect  
                    what's our client needed and focus on this based
                    on visual hierarchy
			<b>to attract user's eye on important sections in software.</b>
		</p>,
		'img': img[3]
	},
	{
		'id': 5,
		'tit':'step 4:',
		'p': <div className="des-p">
			<p>
				<b>in fourth step</b>
				<br />one of our front-end Developers will coding the project by the best technology which
                        help this project to be more attractive and to save best
                        performance in our project our Developers have a good experience in the
                        following technology:
			</p>
			<ol className="row">
				<li className="col-md-6">html</li>
				<li className="col-md-6">react</li>
				<li className="col-md-6">javascript</li>
				<li className="col-md-6">pug js</li>
				<li className="col-md-6">sass</li>
				<li className="col-md-6">gulp</li>
				<li className="col-md-6">reactNative</li>
				<li className="col-md-6">WASM</li>
				<li className="col-md-6">electron</li>
				<li className="col-md-6">etc...</li>
			</ol>
			<p>
                        we will provide the best quality and performance in this step
                        we finished the frontend stages and in the following step we
                        will start animation steps and testing processes, refactor and prepare the performance report.
			</p>
		</div>,
		'img': img[4]
	},
	{
		'id': 6,
		'tit':'step 5:',
		'p': <div className="des-p">
			<b>in this step:</b>
			<br />
			<p>
                        we will start animation and add the sprite in our app
                        we will spechiallized our project by add the life in this
                        project will start add animation in all elements by the
                        following technology:
			</p>
			<ol>
				<li>green sock</li>
				<li>aos library</li>
				<li>animated library</li>
                        in some cases we using :<li>three library</li>
			</ol>
			<p>finally we will have attractive , easy, unique app.</p>
		</div>,
		'video': img[5]
	},
	{
		'id': 7,
		'tit':'step 6:',
		'p': <div className="des-p">
			<p>
				<b>SEO</b>
				<br />
                        search engine optimization to be in first result of search on
                        all pouplar search engien by provided that
			</p>
			<ol>
				<li>clean code</li>
				<li>search engine friendly</li>
				<li>web accessibilty</li>
				<li>good keywords & more security for all app</li>
			</ol>
		</div>,
		'img': img[6]
	},
	{
		'id': 8,
		'tit':'step 7:',
		'p': <div className="des-p">
			<p>
				<b>in this step:</b>
				<br />
                    we will start testing and check prossece to make sure every
                    thing work as we want in all elements in four levels :
			</p>
			<ol className="row">
				<li className="col-md-6">Unit Tests</li>
				<li className="col-md-6">Snapshots Tests</li>
				<li className="col-md-6">Integrations Tests</li>
				<li className="col-md-6">End to End Tests</li>
			</ol>
			<p>by using the folowing technologies</p>
			<ol className="row">
				<li className="col-md-6">Jest</li>
				<li className="col-md-6">mockup</li>
				<li className="col-md-6">assertion</li>
				<li className="col-md-6">Selenium</li>
			</ol>
			<p>
                        finally we will send a testing result as a report for you to
                        know every thing about the project testing Step.
			</p>
		</div>,
		'img': img[7]
	},
	{
		'id': 9,
		'tit':'step 8:',
		'p': <p className="des-p">
			<b>after testing Process</b>
			<br />
                    now one of our Backend Developers will prepare the environment and database for the
                    back-end stage by choosing the best patterns for data structure
                    that makes the fetch data process easy and quickly
		</p>,
		'img': img[8]
	},
	{
		'id': 10,
		'tit':'step 9:',
		'p': <div className="des-p">
			<p>
				<b>Back-end Stage:</b>
				<br />
                    start Backend divelpment process to store project data in our
                    database by using sonme technologies like theses:
			</p>
			<ol>
				<li>Python</li>
				<li>Django</li>
				<li>PostgresSql</li>
				<li>mongodb</li>
			</ol>
		</div>,
		'img': img[9]
	},
	{
		'id': 11,
		'tit':'step 10:',
		'p': <div className="des-p">
			<p>
				<b>Backend Testing Process:</b>
				<br />
                        Testing the Back-end process to make sure the fetching data
                        process is done correctly and with the best performance and
                        without any bugs in all predictions by using theses
                        technologies
			</p>
			<ol>
				<li>Data factory</li>
				<li>Data Generator</li>
				<li>Turbodata</li>
			</ol>
		</div>,
		'img': img[10]
	},
	{
		'id': 12,
		'tit':'step 11:',
		'p': <p className="des-p">
			<b>final step</b>
			<br />
                    uploading the project on any hosting platform or store to make it
                    avalliable for your clintes to using it and (booket or buing
                    or sell or any service you are providing on the app) easily
                    without any effort and keep their time
		</p>,
		'img': img[11]
	},
	{
		'id': 13,
		'tit':'Finally',
		'p': <div className="des-p">
			<p><b>you can</b></p>
			<ol>
				<li>
					<b>the golden plan</b>: subscribe with us to get all
                        support for this project and improv it every 6 months by
                        low cost compare than request a new project
				</li>
				<li>
					<b>the silver plan</b>: get maintance for this project
                        free for 7 days then you will have an offer on all our
                        services 50% per maintance process in this project
				</li>
				<li>
					<b>the bronze plan</b>: get maintance for this project
                        free for 7 days then you will have a point per maintance
                        process in this project to buy any service or product from
                        SASKE Company by the points you had
				</li>
			</ol>
		</div>,
		'img': img[12]
	},

];

export default ContData;